'use client';
import getLocal from 'eco-design-reliance/getLocal';
import getCurrentEffect from '../utils/getCurrentEffect';
import WidgetsItemMicrosoftChat from '../widgets-items/widgets-item-MicrosoftChat';
import { useScrollDirection } from '../utils/useScrollDirection';

export default function WidgetsBottomCenter({ __globar_bottom_v2 = [] }: { __globar_bottom_v2: any[] }) {
    const __globar_bottom_list = __globar_bottom_v2 || [];
    const { pathname } = getLocal();
    const microsoftChatItemA = __globar_bottom_list.find((itemA: any) => {
        return itemA.widgetType === 'CHAT';
    });
    const isOpenMicrosoftChatItemA = !!microsoftChatItemA;
    const { showWidget } = useScrollDirection({});
    // 暂时去掉底部挂件，直接设置成false
    const hidden = false;
    return hidden && getCurrentEffect(microsoftChatItemA, pathname) ? (
        <div className={`WidgetsBottomCenter ${!isOpenMicrosoftChatItemA || !showWidget ? 'bottom-hide' : ''}`}>
            <div className="Widgets-box-in1">
                {isOpenMicrosoftChatItemA && getCurrentEffect(microsoftChatItemA, pathname) && (
                    <WidgetsItemMicrosoftChat position="bottom" microsoftChatItemA={microsoftChatItemA} />
                )}
                {/* <WidgetsItemHoldMail position="bottom" /> */}
            </div>
        </div>
    ) : (
        <></>
    );
}
